/* # =================================================================
# ヘッダーのサブメニューで使用
# ================================================================= */

export default function submenu() {
	document.querySelectorAll('.header__has-sub-menu').forEach(function (element) {
		element.addEventListener('mouseenter', function () {
			var submenu = this.querySelector('.header__sub-menus');
			if (submenu) {
				submenu.style.display = 'block';
			}
		});

		element.addEventListener('mouseleave', function () {
			var submenu = this.querySelector('.header__sub-menus');
			if (submenu) {
				submenu.style.display = 'none';
			}
		});
	});
}